import Vue from 'vue'
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'
import { ValidationProvider } from 'vee-validate'

Vue.component(FeatherIcon.name, FeatherIcon)
Vue.component('ValidationProvider', ValidationProvider)
